import styled from "@emotion/styled";

export const StyledButton = styled.button`
  display: inline-block;
  border-radius: 2px;
  border: none;
  text-transform: uppercase;
  text-align: center;
  padding: 12px 15px;
  line-height: 1;
  position: relative;
  outline: none;
  font-family: inherit;
  padding: 6px 10px;
  font-size: 11px;
  text-transform: none;
  margin-right: 3px;

  svg {
    margin-right: 6px;
    width: 18px;
    height: 18px;
    fill: var(--builder-text-color);
    opacity: 0.9;
  }

  &.dark {
    font-weight: bold;
    color: #fff;
    background: var(--builder-button-dark);
    opacity: 0.9;
    border: 1px solid var(--builder-button-dark-border);
    border-radius: 3px;

    :hover {
      opacity: 1;
    }
    :active {
      opacity: 0.8 !important;
    }
    :focus {
      box-shadow: 0 0 0 1px var(--builder-focus-outline) inset;
    }
    .disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }

  &.add {
    padding: 6px 10px;
    font-size: 11px;
    text-transform: none;
    margin-right: 3px;
  }
`;
